<mat-form-field appearance="none" class="input search">
  <label>
    <input type="search" matInput autocomplete="off" (keyup)="changed(searchInput.value)" #searchInput>
  </label>
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
